<template>
  <el-container class="app-wrapper" :data-layout="themeConfig.layoutMode">
    <el-header height="56px" class="app-header" :data-header="themeConfig.headerStyle">
      <div class="header-left">
        <span class="sidebar-toggle" @click="sidebarCollapsed = !sidebarCollapsed" :title="sidebarCollapsed ? '展开菜单' : '收起菜单'">
          <i :class="sidebarCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
        </span>
        <div class="logo" @click="_toIndex">{{ systemInfo.systemSimpleTitle }}</div>
        <template v-if="!isTopNavMode">
          <div class="header-breadcrumb">
            <span class="breadcrumb-item" v-if="curCatalogName">{{ curCatalogName }}</span>
            <span class="breadcrumb-sep" v-if="curCatalogName && curMenuName">/</span>
            <span class="breadcrumb-item active" v-if="curMenuName">{{ curMenuName }}</span>
          </div>
        </template>
        <div class="top-nav-menu" v-else>
          <el-menu
            mode="horizontal"
            :default-active="'top-catalog-' + activeTopCatalogIndex"
            background-color="transparent"
            @select="handleTopNavSelect"
          >
            <el-menu-item
              v-for="(catalog, catIdx) in allMenuTree"
              :key="'top-cat-' + catIdx"
              :index="'top-catalog-' + catIdx"
            >
              <i class="fa" :class="catalog.icon || (catalog.specialAction ? 'fa-external-link' : 'fa-th-large')"></i>
              <span>{{ catalog.name }}</span>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
      <div class="header-right">
        <el-dropdown @command="changeCommunity" v-if="storeInfo.storeTypeCd == '800900000003'" class="margin-right">
          <span class="user-info">
            {{ curCommunityName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="c" v-for="(c, index) in communitys" :key="index">{{ c.name }}</el-dropdown-item>
            <el-dropdown-item command="moreCommunity" class="moreCommunity">{{ $t('layout.moreCommunity') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown @command="handleCommand">
          <span class="user-info">
            {{ username }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">{{ $t('layout.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="version">{{ systemInfo.version }}</span>
        <span class="settings-btn" @click="settingsVisible = true">
          <i class="el-icon-setting"></i>
        </span>
      </div>
    </el-header>

    <el-container>
      <el-aside class="app-aside" :width="sidebarCollapsed ? '64px' : '220px'" :data-sidebar="themeConfig.sidebarStyle" :data-collapsed="sidebarCollapsed" v-show="!isTopNavMode || sidebarMenuData.length > 0">
        <div class="sidebar-search" v-if="!sidebarCollapsed">
          <el-input
            v-model="menuSearchText"
            placeholder="搜索菜单..."
            prefix-icon="el-icon-search"
            size="small"
            clearable
          />
        </div>
        <div class="sidebar-menu" id="menu-nav" v-loading="menuLoading">
          <el-scrollbar class="sidebar-scrollbar">
            <el-menu
              class="nav-menu"
              mode="vertical"
              :unique-opened="false"
              :default-active="activeMenu"
              background-color="transparent"
            >
              <!-- ========== 侧栏模式：三级菜单 ========== -->
              <template v-if="!isTopNavMode">
                <template v-for="(catalog, catIdx) in filteredMenuTree">
                  <el-menu-item
                    v-if="catalog.specialAction"
                    :key="'cat-item-' + catIdx"
                    :index="'catalog-' + catIdx"
                    @click="handleCatalogClick(catalog)"
                  >
                    <i class="fa" :class="catalog.icon || 'fa-external-link'"></i>
                    <span>{{ catalog.name }}</span>
                  </el-menu-item>
                  <el-submenu
                    v-else-if="catalog.childs && catalog.childs.length > 0"
                    :key="'cat-sub-' + catIdx"
                    :index="'catalog-' + catIdx"
                  >
                    <template #title>
                      <i class="fa" :class="catalog.icon || 'fa-th-large'"></i>
                      <span>{{ catalog.name }}</span>
                    </template>
                    <template v-for="(menu, mIdx) in catalog.childs">
                      <el-submenu
                        v-if="menu.childs && getVisibleChilds(menu.childs).length > 0"
                        :key="'sub2-' + catIdx + '-' + mIdx"
                        :index="menu.id || 'sub2-' + catIdx + '-' + mIdx"
                      >
                        <template #title>
                          <i v-if="menu.icon" class="fa" :class="menu.icon"></i>
                          <span>{{ menu.name }}</span>
                        </template>
                        <el-menu-item
                          v-for="(gc, gcIdx) in getVisibleChilds(menu.childs)"
                          :key="'gc-' + catIdx + '-' + mIdx + '-' + gcIdx"
                          :index="gc.id || 'gc-' + catIdx + '-' + mIdx + '-' + gcIdx"
                          @click="handleSubMenuClick(gc, menu)"
                        >
                          <i v-if="gc.icon" class="fa" :class="gc.icon"></i>
                          <span>{{ gc.name }}</span>
                        </el-menu-item>
                      </el-submenu>
                      <el-menu-item
                        v-else
                        :key="'item-' + catIdx + '-' + mIdx"
                        :index="menu.id || 'item-' + catIdx + '-' + mIdx"
                        @click="handleMenuClick(menu, catalog)"
                      >
                        <i v-if="menu.icon" class="fa" :class="menu.icon"></i>
                        <span>{{ menu.name }}</span>
                      </el-menu-item>
                    </template>
                  </el-submenu>
                </template>
              </template>
              <!-- ========== 顶部导航模式：仅二级+三级 ========== -->
              <template v-else>
                <template v-for="(menu, mIdx) in filteredMenuTree">
                  <el-submenu
                    v-if="menu.childs && getVisibleChilds(menu.childs).length > 0"
                    :key="'tn-sub-' + mIdx"
                    :index="menu.id || 'tn-sub-' + mIdx"
                  >
                    <template #title>
                      <i v-if="menu.icon" class="fa" :class="menu.icon"></i>
                      <span>{{ menu.name }}</span>
                    </template>
                    <el-menu-item
                      v-for="(gc, gcIdx) in getVisibleChilds(menu.childs)"
                      :key="'tn-gc-' + mIdx + '-' + gcIdx"
                      :index="gc.id || 'tn-gc-' + mIdx + '-' + gcIdx"
                      @click="handleSubMenuClick(gc, menu)"
                    >
                      <i v-if="gc.icon" class="fa" :class="gc.icon"></i>
                      <span>{{ gc.name }}</span>
                    </el-menu-item>
                  </el-submenu>
                  <el-menu-item
                    v-else
                    :key="'tn-item-' + mIdx"
                    :index="menu.id || 'tn-item-' + mIdx"
                    @click="handleTopNavMenuClick(menu)"
                  >
                    <i v-if="menu.icon" class="fa" :class="menu.icon"></i>
                    <span>{{ menu.name }}</span>
                  </el-menu-item>
                </template>
              </template>
            </el-menu>
          </el-scrollbar>
        </div>
      </el-aside>

      <el-main class="app-main" :data-tabs="themeConfig.tabsStyle">
        <div class="tabs-wrap" v-if="visitedTabs.length > 0">
          <div class="tabs-scroll-btn tabs-scroll-left" @click="scrollTabs(-200)" v-show="canScrollLeft">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div class="tabs-list" ref="tabsList" @scroll="onTabsScroll">
            <div
              v-for="tab in visitedTabs"
              :key="tab.path"
              :class="['tabs-item', { active: $route.path === tab.path }]"
              @click="goTab(tab)"
            >
              <span class="tabs-item-title">{{ tab.titleKey ? $t(tab.titleKey) : tab.title }}</span>
              <i class="el-icon-close tabs-item-close" @click.stop="removeTab(tab)" v-if="visitedTabs.length > 1"></i>
            </div>
          </div>
          <div class="tabs-scroll-btn tabs-scroll-right" @click="scrollTabs(200)" v-show="canScrollRight">
            <i class="el-icon-arrow-right"></i>
          </div>
          <el-dropdown class="tabs-close-dropdown" @command="handleTabCommand">
            <span class="tabs-close-all">
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="closeAll">{{ $t('layout.closeAllTabs') }}</el-dropdown-item>
              <el-dropdown-item command="closeOther">关闭其他</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-scrollbar class="main-scrollbar" wrap-class="main-scrollbar-wrap">
          <div class="main-content-padding">
            <div class="main-content-view">
              <router-view />
            </div>
          </div>
        </el-scrollbar>
      </el-main>
    </el-container>

    <el-drawer
      title="主题设置"
      :visible.sync="settingsVisible"
      direction="rtl"
      size="280px"
      :append-to-body="true"
      class="theme-drawer"
    >
      <div class="settings-section">
        <div class="settings-label">布局模式</div>
        <div class="layout-mode-options">
          <div
            class="layout-mode-option"
            :class="{ active: themeConfig.layoutMode === 'sidebar' }"
            @click="setLayoutMode('sidebar')"
          >
            <div class="layout-mode-preview layout-preview-sidebar">
              <div class="lp-sidebar-bar"></div>
              <div class="lp-sidebar-header"></div>
              <div class="lp-sidebar-main"></div>
            </div>
            <span class="layout-mode-text">侧栏布局</span>
          </div>
          <div
            class="layout-mode-option"
            :class="{ active: themeConfig.layoutMode === 'topNav' }"
            @click="setLayoutMode('topNav')"
          >
            <div class="layout-mode-preview layout-preview-topnav">
              <div class="lp-topnav-header"></div>
              <div class="lp-topnav-sidebar"></div>
              <div class="lp-topnav-main"></div>
            </div>
            <span class="layout-mode-text">顶部导航</span>
          </div>
        </div>
      </div>

      <div class="settings-section">
        <div class="settings-label">主题色</div>
        <div class="color-picker-row">
          <span
            v-for="color in presetColors"
            :key="color"
            class="color-dot"
            :class="{ active: themeConfig.primary === color }"
            :style="{ background: color }"
            @click="setPrimaryColor(color)"
          ></span>
          <el-color-picker
            v-model="themeConfig.primary"
            size="mini"
            @change="applyTheme"
          />
        </div>
      </div>

      <div class="settings-section">
        <div class="settings-label">顶栏风格</div>
        <div class="style-options">
          <div
            v-for="opt in headerStyleOptions"
            :key="opt.value"
            class="style-option"
            :class="{ active: themeConfig.headerStyle === opt.value }"
            @click="setHeaderStyle(opt.value)"
          >
            <div class="style-preview" :style="opt.previewStyle">
              <span class="style-preview-bar" :style="opt.barStyle"></span>
            </div>
            <span class="style-option-text">{{ opt.label }}</span>
          </div>
        </div>
      </div>

      <div class="settings-section">
        <div class="settings-label">侧栏风格</div>
        <div class="style-options">
          <div
            v-for="opt in sidebarStyleOptions"
            :key="opt.value"
            class="style-option"
            :class="{ active: themeConfig.sidebarStyle === opt.value }"
            @click="setSidebarStyle(opt.value)"
          >
            <div class="style-preview" :style="opt.previewStyle">
              <span class="style-preview-sidebar" :style="opt.sidebarStyle"></span>
            </div>
            <span class="style-option-text">{{ opt.label }}</span>
          </div>
        </div>
      </div>

      <div class="settings-section">
        <div class="settings-label">标签页风格</div>
        <div class="style-options">
          <div
            v-for="opt in tabsStyleOptions"
            :key="opt.value"
            class="style-option"
            :class="{ active: themeConfig.tabsStyle === opt.value }"
            @click="setTabsStyle(opt.value)"
          >
            <div class="style-preview-tabs">
              <span class="tabs-mock" :class="opt.value"></span>
            </div>
            <span class="style-option-text">{{ opt.label }}</span>
          </div>
        </div>
      </div>
    </el-drawer>

    <more-community ref="moreCommunity" />
    <view-menu-user-list ref="viewMenuUserModel" />
    <search-community-data-list ref="searchCommunityDataModel" />
  </el-container>
</template>

<script>
import { _getMenuCatalog, getMenuTree, jumpToMall, jumpToIot } from '@/api/user/menuApi'
import { getStoreInfo } from "@/api/user/indexApi"
import { listSystemInfo } from '@/api/system/systemInfoManageApi'
import { deepCopy, setCurrentCommunity } from "@/utils/vc"
import { getCommunityName, _loadCommunityInfo } from '@/api/community/communityApi'
import moreCommunity from '@/components/community/moreCommunity.vue'
import viewMenuUserList from '@/components/system/viewMenuUserList.vue'
import searchCommunityDataList from '@/components/system/searchCommunityDataList.vue'
import { initSystem } from '@/api/util/vcApi'
import config from '@/conf/config'

export default {
  name: 'Layout',
  data() {
    return {
      catalogs: [],
      allMenuTree: [],
      menuTree: [],
      subMenus: [],
      menuWidth: 80,
      menuId: '',
      curMenuName: '',
      curCatalogName: '',
      activeMenu: '',
      activeSubMenu: 'communityList',
      searchText: '',
      menuSearchText: '',
      sidebarCollapsed: false,
      username: '',
      curCommunityName: '',
      communitys: [],
      menuLoading: false,
      storeInfo: {
        storeTypeCd: '',
        storeId: ''
      },
      systemInfo: {
        systemSimpleTitle: '',
        companyName: '',
        logoUrl: '',
        version: ''
      },
      visitedTabs: [],
      canScrollLeft: false,
      canScrollRight: false,
      settingsVisible: false,
      presetColors: ['#3B82F6', '#6366F1', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6'],
      headerStyleOptions: [
        { value: 'light', label: '浅色', previewStyle: { background: '#fff', border: '1px solid #eee' }, barStyle: { background: '#f5f7fa' } },
        { value: 'dark', label: '深色', previewStyle: { background: '#0B1120' }, barStyle: { background: 'rgba(255,255,255,0.1)' } },
        { value: 'primary', label: '主题色', previewStyle: { background: '#3B82F6' }, barStyle: { background: 'rgba(255,255,255,0.15)' } }
      ],
      sidebarStyleOptions: [
        { value: 'light', label: '浅色', previewStyle: { background: '#fff', border: '1px solid #eee' }, sidebarStyle: { background: '#f5f7fa' } },
        { value: 'dark', label: '深色', previewStyle: { background: '#0B1120' }, sidebarStyle: { background: 'rgba(255,255,255,0.08)' } },
        { value: 'primary', label: '主题色', previewStyle: { background: '#3B82F6' }, sidebarStyle: { background: 'rgba(255,255,255,0.15)' } }
      ],
      tabsStyleOptions: [
        { value: 'card', label: '卡片' },
        { value: 'smooth', label: '圆滑' },
        { value: 'chunk', label: '色块' }
      ],
      activeTopCatalogIndex: -1,
      lastNormalTopCatalogIndex: 0,
      themeConfig: {
        primary: '#3B82F6',
        headerStyle: 'light',
        sidebarStyle: 'light',
        tabsStyle: 'smooth',
        layoutMode: 'topNav'
      }
    }
  },
  computed: {
    isTopNavMode() {
      return this.themeConfig.layoutMode === 'topNav'
    },
    sidebarMenuData() {
      if (this.isTopNavMode && this.activeTopCatalogIndex >= 0) {
        const catalog = this.allMenuTree[this.activeTopCatalogIndex]
        if (catalog && catalog.childs) {
          return catalog.childs
        }
        return []
      }
      return this.allMenuTree
    },
    filteredMenuTree() {
      const keyword = (this.menuSearchText || '').trim().toLowerCase()
      if (!keyword) return this.sidebarMenuData
      const filter = (items) => {
        if (!items) return []
        return items.filter(item => {
          const nameMatch = (item.name || '').toLowerCase().includes(keyword)
          const childMatch = item.childs && filter(item.childs).length > 0
          return nameMatch || childMatch
        }).map(item => {
          if (item.childs) {
            return { ...item, childs: filter(item.childs) }
          }
          return item
        })
      }
      return filter(this.sidebarMenuData)
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (!route.path || route.path === '/views/user/login' || route.path === '/login') return
        const path = route.path
        const exists = this.visitedTabs.some(t => t.path === path)
        if (!exists) {
          const info = this.getTabTitle(path, route.meta || {})
          if (info) this.visitedTabs.push({ path, ...info })
        }
        this.updateCurMenuName()
        if (this.isTopNavMode) {
          this.syncTopNavToRoute()
        }
        this.scrollToActiveTab()
      },
      immediate: true
    }
  },
  created() {
    this.restoreTheme()
    let _user = JSON.parse(localStorage.getItem('user'));
    this.username = _user.name
    this.systemInfo.version = config.version
    this.getSystemInfo()
    this._loadStoreInfo()
    this.loadCatalogs()
    this.curCommunityName = getCommunityName()
    this.loadCommunity()
    initSystem()
  },
  components: {
    moreCommunity,
    viewMenuUserList,
    searchCommunityDataList
  },
  methods: {
    getTabTitle(path, meta) {
      if (path === '/views/index/index' || path === '/') {
        return { titleKey: 'layout.home' }
      }
      const m = meta || {}
      if (m.title) return { title: m.title }
      if (m.titleKey) return { titleKey: m.titleKey }
      return null
    },
    updateCurMenuName() {
      const currentPath = this.$route.path
      if (currentPath === '/views/index/index' || currentPath === '/') {
        this.curMenuName = this.$t('layout.home')
        return
      }
      for (let menu of this.menuTree) {
        if (menu.childs) {
          for (let child of menu.childs) {
            if (child.childs) {
              for (let gc of child.childs) {
                if (gc.active) {
                  this.curMenuName = gc.name
                  return
                }
              }
            }
            if (child.active) {
              this.curMenuName = child.name
              return
            }
          }
        } else if (menu.active) {
          this.curMenuName = menu.name
          return
        }
      }
    },
    goTab(tab) {
      if (this.$route.path === tab.path) return
      this.$router.push(tab.path).catch(() => {})
    },
    removeTab(tab) {
      const list = this.visitedTabs.filter(t => t.path !== tab.path)
      this.visitedTabs = list
      if (this.$route.path === tab.path) {
        const next = list.length ? list[list.length - 1] : { path: '/views/index/index' }
        this.$router.push(next.path).catch(() => {})
      }
    },
    closeAllTabs() {
      this.visitedTabs = []
      this.$router.push('/views/index/index').catch(() => {})
    },
    closeOtherTabs() {
      const cur = this.visitedTabs.find(t => t.path === this.$route.path)
      this.visitedTabs = cur ? [cur] : []
    },
    handleTabCommand(cmd) {
      if (cmd === 'closeAll') this.closeAllTabs()
      else if (cmd === 'closeOther') this.closeOtherTabs()
    },
    scrollTabs(delta) {
      if (this.$refs.tabsList) {
        this.$refs.tabsList.scrollLeft += delta
        this.onTabsScroll()
      }
    },
    onTabsScroll() {
      const el = this.$refs.tabsList
      if (!el) return
      this.canScrollLeft = el.scrollLeft > 0
      this.canScrollRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 1
    },
    scrollToActiveTab() {
      this.$nextTick(() => {
        const el = this.$refs.tabsList
        if (!el) return
        const active = el.querySelector('.tabs-item.active')
        if (active) {
          active.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' })
        }
        this.onTabsScroll()
      })
    },
    async getSystemInfo() {
      const { data } = await listSystemInfo({ page: 1, row: 1 });
      this.systemInfo.systemSimpleTitle = data[0].systemSimpleTitle
      this.systemInfo.companyName = data[0].companyName
      this.systemInfo.logoUrl = data[0].logoUrl
    },
    async loadCommunity() {
      const { communitys } = await _loadCommunityInfo()
      this.communitys = communitys
      this.curCommunityName = getCommunityName()
    },
    async _loadStoreInfo() {
      this.loading = true
      try {
        const res = await getStoreInfo()
        deepCopy(res, this.storeInfo);
      } catch (error) {
        console.error('登录失败：', error)
      } finally {
        this.loading = false
      }
    },
    async loadCatalogs() {
      this.menuLoading = true
      try {
        const res = await _getMenuCatalog()
        if (res.code != 0) return
        this.catalogs = res.data
        if (!this.catalogs || this.catalogs.length === 0) return

        // 并行加载所有目录菜单，避免串行请求瀑布
        const tree = await Promise.all(
          this.catalogs.map(async (cat) => {
            // 特殊目录（IOT/MALL/弹窗）直接作为特殊项
            if (cat.url === 'IOT' || cat.url === 'MALL' || (cat.url && cat.url.startsWith('?'))) {
              return {
                id: cat.caId,
                name: cat.name,
                icon: cat.icon || 'fa-external-link',
                childs: null,
                specialAction: true,
                catalogData: cat
              }
            }

            // 普通目录：加载菜单树
            try {
              const menuRes = await getMenuTree(cat)
              let menus = menuRes.data || []
              if (!Array.isArray(menus)) menus = []
              menus.sort((a, b) => (a.seq || 0) - (b.seq || 0))
              menus.forEach(m => {
                m.isOpen = false
                m.active = false
                if (m.childs && Array.isArray(m.childs)) {
                  m.childs.sort((c1, c2) => (c1.seq || 0) - (c2.seq || 0))
                  m.childs.forEach(c => {
                    c.active = false
                    if (c.childs && Array.isArray(c.childs)) {
                      c.childs.sort((g1, g2) => (g1.seq || 0) - (g2.seq || 0))
                      c.childs.forEach(gc => { gc.active = false })
                    }
                  })
                }
              })
              return {
                id: cat.caId,
                name: cat.name,
                icon: cat.icon || 'fa-th-large',
                childs: menus,
                isCatalog: true,
                catalogData: cat
              }
            } catch (e) {
              console.error('加载目录菜单失败[' + cat.name + ']：', e)
              return null
            }
          })
        )
        // 过滤掉加载失败的目录
        const validTree = tree.filter(item => item !== null)

        this.allMenuTree = validTree
        this.menuTree = validTree

        if (this.isTopNavMode) {
          this.restoreTopNavSelection()
        }

        this.$nextTick(() => {
          const found = this.expandMenuByRoute()
          if (!found) {
            this.navigateToFirstMenu(validTree)
          }
          this.fixMenuPadding()
        })
      } catch (error) {
        console.error('加载目录失败：', error)
      } finally {
        this.menuLoading = false
      }
    },
    handleCatalogClick(catalog) {
      if (catalog.catalogData) {
        this._changeMenuCatalog(catalog.catalogData, true)
      }
    },
    handleMenuClick(menu, catalog) {
      // 清除所有 active
      this.clearAllActive()
      menu.active = true
      this.curCatalogName = catalog.name
      this.curMenuName = menu.name
      this.activeMenu = menu.id || ''
      if (menu.href) {
        this._gotoPage(menu.href)
      }
    },
    handleSubMenuClick(gc) {
      this.clearAllActive()
      gc.active = true
      this.curMenuName = gc.name
      this.activeMenu = gc.id || ''
      if (gc.href) {
        this._gotoPage(gc.href)
      }
    },
    clearAllActive() {
      for (let catalog of this.allMenuTree) {
        if (catalog.childs) {
          for (let menu of catalog.childs) {
            menu.active = false
            if (menu.childs) {
              for (let c of menu.childs) {
                c.active = false
                if (c.childs) {
                  for (let gc of c.childs) {
                    gc.active = false
                  }
                }
              }
            }
          }
        }
      }
    },
    getVisibleChilds(childs) {
      if (!childs) return []
      return childs.filter(c => c.isShow !== 'N')
    },
    expandMenuByRoute() {
      const currentPath = this.$route.path
      if (currentPath === '/views/index/index' || currentPath === '/') return true

      for (let catIdx = 0; catIdx < this.allMenuTree.length; catIdx++) {
        const catalog = this.allMenuTree[catIdx]
        if (catalog.childs) {
          for (let menu of catalog.childs) {
            if (menu.childs) {
              for (let gc of menu.childs) {
                if (gc.href && (currentPath === gc.href || currentPath.includes(gc.href))) {
                  this.curCatalogName = catalog.name
                  gc.active = true
                  this.activeMenu = gc.id || ''
                  if (this.isTopNavMode) {
                    this.activeTopCatalogIndex = catIdx
                    this.lastNormalTopCatalogIndex = catIdx
                  }
                  return true
                }
              }
            }
            if (menu.href && (currentPath === menu.href || currentPath.includes(menu.href))) {
              this.curCatalogName = catalog.name
              menu.active = true
              this.activeMenu = menu.id || ''
              if (this.isTopNavMode) {
                this.activeTopCatalogIndex = catIdx
                this.lastNormalTopCatalogIndex = catIdx
              }
              return true
            }
          }
        }
      }
      return false
    },
    navigateToFirstMenu(tree) {
      for (let catIdx = 0; catIdx < tree.length; catIdx++) {
        const catalog = tree[catIdx]
        if (catalog.childs && catalog.childs.length > 0) {
          const first = catalog.childs[0]
          if (first.childs && first.childs.length > 0) {
            const gc = first.childs[0]
            this.curCatalogName = catalog.name
            gc.active = true
            this.activeMenu = gc.id || ''
            if (this.isTopNavMode) {
              this.activeTopCatalogIndex = catIdx
              this.lastNormalTopCatalogIndex = catIdx
            }
            if (gc.href) this._gotoPage(gc.href)
          } else {
            this.curCatalogName = catalog.name
            first.active = true
            this.activeMenu = first.id || ''
            if (this.isTopNavMode) {
              this.activeTopCatalogIndex = catIdx
              this.lastNormalTopCatalogIndex = catIdx
            }
            if (first.href) this._gotoPage(first.href)
          }
          return
        }
      }
    },
    fixMenuPadding() {
      const menu = document.getElementById('menu-nav')
      if (!menu) return
      menu.querySelectorAll('.el-menu-item, .el-submenu__title')
    },
    _changeMenuCatalog(_catalog, _isJump) {
      this.activeMenu = _catalog.caId
      this.curCatalogName = _catalog.name
      if (this._showModelDiv(_catalog)) {
        return
      }
      if (_catalog.url == 'IOT') {
        jumpToIot('/')
        return
      }
      if (_catalog.url == 'MALL') {
        jumpToMall('/')
        return
      }
      if (_catalog.url != '#' && _isJump) {
        this._gotoPage(_catalog.url)
      }
    },
    handleCommand(command) {
      if (command === 'logout') {
        const themeConfig = localStorage.getItem('themeConfig')
        localStorage.clear()
        if (themeConfig) {
          localStorage.setItem('themeConfig', themeConfig)
        }
        this.$router.push('/login')
      } else if (command === 'zh' || command === 'en') {
        this.$i18n.locale = command
        localStorage.setItem('language', command)
      }
    },
    changeCommunity(community) {
      if (community == 'moreCommunity') {
        this.$refs.moreCommunity.open()
        return
      }
      setCurrentCommunity(community)
      this.curCommunityName = getCommunityName()
      window.location.href = "/"
    },
    _gotoPage(_href) {
      if (_href.indexOf('.html') > -1) {
        window.open(_href, '_blank')
        return
      }
      if (_href.indexOf('/#/') > -1) {
        _href = _href.replace('/#/', '/')
      }
      this.$router.push(_href).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    },
    _showModelDiv: function (_catalog) {
      if (_catalog.url && _catalog.url.startsWith('?')) {
        let _modelName = _catalog.url.substring(1, _catalog.url.length)
        this.$refs[_modelName].open()
        return true
      }
      return false
    },
    _toIndex() {
      location.href = '/'
    },
    // 主题相关方法
    restoreTheme() {
      const saved = localStorage.getItem('themeConfig')
      if (saved) {
        try {
          const config = JSON.parse(saved)
          Object.assign(this.themeConfig, config)
        } catch (e) { /* ignore */ }
      }
      this.applyTheme()
    },
    saveTheme() {
      localStorage.setItem('themeConfig', JSON.stringify(this.themeConfig))
    },
    applyTheme() {
      document.documentElement.style.setProperty('--primary-color', this.themeConfig.primary)
      document.documentElement.style.setProperty('--primary-light', this.themeConfig.primary + '15')
      document.documentElement.style.setProperty('--primary-hover', this.themeConfig.primary + 'dd')
      this.saveTheme()
    },
    setPrimaryColor(color) {
      this.themeConfig.primary = color
      this.applyTheme()
    },
    setHeaderStyle(style) {
      this.themeConfig.headerStyle = style
      this.saveTheme()
    },
    setSidebarStyle(style) {
      this.themeConfig.sidebarStyle = style
      this.saveTheme()
    },
    setTabsStyle(style) {
      this.themeConfig.tabsStyle = style
      this.saveTheme()
    },
    setLayoutMode(mode) {
      this.themeConfig.layoutMode = mode
      if (mode === 'topNav') {
        const firstNormalIdx = this.allMenuTree.findIndex(c => !c.specialAction && c.childs && c.childs.length > 0)
        if (firstNormalIdx >= 0) {
          this.activeTopCatalogIndex = firstNormalIdx
          this.lastNormalTopCatalogIndex = firstNormalIdx
          this.curCatalogName = this.allMenuTree[firstNormalIdx].name
        }
      } else {
        this.activeTopCatalogIndex = -1
      }
      this.saveTheme()
    },
    handleTopNavSelect(index) {
      const catIdx = parseInt(index.replace('top-catalog-', ''), 10)
      const catalog = this.allMenuTree[catIdx]
      if (!catalog) return
      if (catalog.specialAction) {
        this.handleCatalogClick(catalog)
        return
      }
      this.lastNormalTopCatalogIndex = catIdx
      this.activeTopCatalogIndex = catIdx
      this.curCatalogName = catalog.name
      if (catalog.childs && catalog.childs.length > 0) {
        const first = catalog.childs[0]
        if (first.childs && this.getVisibleChilds(first.childs).length > 0) {
          const gc = this.getVisibleChilds(first.childs)[0]
          this.clearAllActive()
          gc.active = true
          this.curMenuName = gc.name
          this.activeMenu = gc.id || ''
          if (gc.href) this._gotoPage(gc.href)
        } else {
          this.clearAllActive()
          first.active = true
          this.curMenuName = first.name
          this.activeMenu = first.id || ''
          if (first.href) this._gotoPage(first.href)
        }
      }
    },
    handleTopNavMenuClick(menu) {
      this.clearAllActive()
      menu.active = true
      this.curMenuName = menu.name
      this.activeMenu = menu.id || ''
      if (menu.href) {
        this._gotoPage(menu.href)
      }
    },
    restoreTopNavSelection() {
      if (!this.isTopNavMode) return
      const currentPath = this.$route.path
      for (let i = 0; i < this.allMenuTree.length; i++) {
        const catalog = this.allMenuTree[i]
        if (!catalog.childs) continue
        for (let menu of catalog.childs) {
          if (menu.href && (currentPath === menu.href || currentPath.includes(menu.href))) {
            this.activeTopCatalogIndex = i
            this.lastNormalTopCatalogIndex = i
            this.curCatalogName = catalog.name
            return
          }
          if (menu.childs) {
            for (let gc of menu.childs) {
              if (gc.href && (currentPath === gc.href || currentPath.includes(gc.href))) {
                this.activeTopCatalogIndex = i
                this.lastNormalTopCatalogIndex = i
                this.curCatalogName = catalog.name
                return
              }
            }
          }
        }
      }
      const firstNormalIdx = this.allMenuTree.findIndex(c => !c.specialAction && c.childs && c.childs.length > 0)
      if (firstNormalIdx >= 0) {
        this.activeTopCatalogIndex = firstNormalIdx
        this.lastNormalTopCatalogIndex = firstNormalIdx
        this.curCatalogName = this.allMenuTree[firstNormalIdx].name
      }
    },
    syncTopNavToRoute() {
      if (!this.isTopNavMode) return
      const currentPath = this.$route.path
      if (currentPath === '/views/index/index' || currentPath === '/') return
      for (let i = 0; i < this.allMenuTree.length; i++) {
        const catalog = this.allMenuTree[i]
        if (!catalog.childs) continue
        for (let menu of catalog.childs) {
          if (menu.href && (currentPath === menu.href || currentPath.includes(menu.href))) {
            this.activeTopCatalogIndex = i
            this.lastNormalTopCatalogIndex = i
            this.curCatalogName = catalog.name
            return
          }
          if (menu.childs) {
            for (let gc of menu.childs) {
              if (gc.href && (currentPath === gc.href || currentPath.includes(gc.href))) {
                this.activeTopCatalogIndex = i
                this.lastNormalTopCatalogIndex = i
                this.curCatalogName = catalog.name
                return
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

// ==================== 顶栏 ====================
.app-header {
  background: #ffffff;
  color: #303133;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  z-index: 100;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.04) 20%, rgba(0, 0, 0, 0.04) 80%, transparent);
  }
}

.app-header[data-header="dark"] {
  background: linear-gradient(135deg, #0B1120 0%, #111827 50%, #0F172A 100%);
  color: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4), 0 0 20px rgba(59, 130, 246, 0.05);

  &::after {
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.05) 20%, rgba(255, 255, 255, 0.05) 80%, transparent);
  }
}

.app-header[data-header="primary"] {
  background: linear-gradient(135deg, var(--primary-color) 0%, color-mix(in srgb, var(--primary-color) 85%, #000) 100%);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  &::after {
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.08) 20%, rgba(255, 255, 255, 0.08) 80%, transparent);
  }
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.logo {
  width: 160px;
  height: 56px;
  line-height: 56px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: var(--primary-color);
  cursor: pointer;
  letter-spacing: 0.02em;
  flex-shrink: 0;
  position: relative;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }
}

.app-header[data-header="dark"] .logo,
.app-header[data-header="primary"] .logo {
  color: #ffffff;
}

.sidebar-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
  font-size: 18px;
  color: #606266;
  flex-shrink: 0;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
    color: var(--primary-color);
  }
}

.app-header[data-header="dark"] .sidebar-toggle,
.app-header[data-header="primary"] .sidebar-toggle {
  color: rgba(255, 255, 255, 0.7);

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
  }
}

.header-breadcrumb {
  font-size: 14px;
  color: #909399;
}

.breadcrumb-item {
  color: #909399;
}

.breadcrumb-item.active {
  color: #303133;
  font-weight: 500;
}

.app-header[data-header="dark"] .breadcrumb-item.active,
.app-header[data-header="primary"] .breadcrumb-item.active {
  color: #ffffff;
}

.breadcrumb-sep {
  margin: 0 8px;
  color: #c0c4cc;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.margin-right {
  margin-right: 8px;
}

.version {
  margin-left: 8px;
  color: #bfbfbf;
  font-size: 12px;
}

.app-header[data-header="dark"] .version,
.app-header[data-header="primary"] .version {
  color: rgba(255, 255, 255, 0.5);
}

.settings-btn {
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s ease;
  font-size: 16px;
  color: #909399;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
    color: #606266;
    transform: rotate(30deg);
  }
}

.app-header[data-header="dark"] .settings-btn,
.app-header[data-header="primary"] .settings-btn {
  color: rgba(255, 255, 255, 0.7);

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
  }
}

.user-info {
  color: #606266;
  cursor: pointer;
  font-size: 14px;
  padding: 6px 12px;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
}

.app-header[data-header="dark"] .user-info,
.app-header[data-header="primary"] .user-info {
  color: #ffffff;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

// ==================== 标签页 ====================
.tabs-wrap {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  background: #fafbfc;
  border-bottom: 1px solid #f0f0f0;
  gap: 4px;
}

.tabs-scroll-btn {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 6px;
  color: #909399;
  flex-shrink: 0;
  transition: all 0.15s ease;

  &:hover {
    background: #e8eaed;
    color: #606266;
  }
}

.tabs-list {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    display: none;
  }
}

.tabs-item {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
  color: #606266;
  background: transparent;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: #e8eaed;
  }

  &.active {
    color: var(--primary-color);
    background: #ffffff;
    font-weight: 500;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  }
}

.app-main[data-tabs="card"] .tabs-item {
  border-radius: 6px;
}

.app-main[data-tabs="smooth"] .tabs-item {
  border-radius: 16px;
}

.app-main[data-tabs="chunk"] .tabs-item.active {
  background: var(--primary-color);
  color: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
}

.tabs-item-title {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tabs-item-close {
  margin-left: 6px;
  font-size: 12px;
  opacity: 0;
  transition: opacity 0.15s;

  &:hover {
    color: #FF4D4F;
  }

  .tabs-item:hover &,
  .tabs-item.active & {
    opacity: 0.7;
  }
}

.tabs-close-dropdown {
  flex-shrink: 0;
}

.tabs-close-all {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  color: #909399;
  transition: all 0.15s ease;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  font-size: 13px;

  &:hover {
    color: var(--primary-color);
    background: var(--primary-light);
    border-color: var(--primary-color);
  }
}

// ==================== 顶部导航模式 ====================
.top-nav-menu {
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;

  &::-webkit-scrollbar {
    display: none;
  }

  // Force the horizontal menu to use flexbox centering
  ::v-deep .el-menu--horizontal {
    border-bottom: none !important;
    height: 56px;
    display: flex !important;
    align-items: center !important;
    gap: 3px;
    background: transparent !important;
  }

  // Each item: use flex centering to guarantee icon+text vertical alignment
  ::v-deep .el-menu--horizontal > .el-menu-item {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: 36px !important;
    line-height: 1 !important;
    font-size: 13.5px;
    font-weight: 500;
    letter-spacing: 0.01em;
    border-bottom: none !important;
    border-radius: 8px;
    margin: 0;
    padding: 0 16px !important;
    position: relative;
    white-space: nowrap;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

    i {
      margin-right: 6px;
      font-size: 15px;
      transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      top: -0.5px;
    }

    &:hover i {
      transform: scale(1.15);
    }
  }
}

// ---- Light header top-nav ----
.app-header[data-header="light"] .top-nav-menu {
  ::v-deep .el-menu--horizontal > .el-menu-item {
    color: #5a6069;
    background: transparent;
    border: 1px solid transparent;

    &:hover {
      color: var(--primary-color);
      background: var(--primary-light) !important;
      border-color: rgba(0, 0, 0, 0.04);
    }

    &.is-active {
      color: #ffffff;
      background: var(--primary-color) !important;
      border-color: transparent;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

      i {
        color: #ffffff;
      }

      &:hover {
        background: var(--primary-hover) !important;
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
        transform: translateY(-1px);
      }
    }
  }
}

// ---- Dark/Primary header top-nav ----
.app-header[data-header="dark"] .top-nav-menu,
.app-header[data-header="primary"] .top-nav-menu {
  ::v-deep .el-menu--horizontal > .el-menu-item {
    color: rgba(255, 255, 255, 0.75);
    background: transparent;
    border: 1px solid transparent;

    &:hover {
      color: #ffffff;
      background: rgba(255, 255, 255, 0.1) !important;
      border-color: rgba(255, 255, 255, 0.08);
    }

    &.is-active {
      color: var(--primary-color);
      background: #ffffff !important;
      border-color: transparent;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);

      i {
        color: var(--primary-color);
      }

      &:hover {
        background: #ffffff !important;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.28);
        transform: translateY(-1px);
      }
    }
  }
}

// ---- TopNav mode sidebar style uplift ----
.app-wrapper[data-layout="topNav"] {
  .sidebar-menu {
    border-right: 1px solid rgba(0, 0, 0, 0.05);
  }

  ::v-deep .nav-menu > .el-submenu > .el-submenu__title {
    padding-left: 14px !important;
    font-weight: 600 !important;
    color: #303133 !important;
    font-size: 14px !important;
    margin: 2px 6px !important;
    border-radius: 8px;

    i {
      color: var(--primary-color);
      font-size: 16px;
      margin-right: 8px;
    }

    &:hover {
      background: var(--primary-light) !important;

      i {
        transform: scale(1.1);
      }
    }
  }

  ::v-deep .nav-menu > .el-menu-item {
    padding-left: 14px !important;
    font-weight: 500 !important;
    color: #303133 !important;
    margin: 2px 6px !important;
    border-radius: 8px;

    i {
      color: var(--primary-color);
      font-size: 16px;
      margin-right: 8px;
      transition: transform 0.2s ease;
    }

    &:hover {
      background: var(--primary-light) !important;

      i {
        transform: scale(1.1);
      }
    }

    &.is-active {
      color: var(--primary-color) !important;
      background: linear-gradient(135deg, var(--primary-light) 0%, rgba(240, 247, 255, 0.5) 100%) !important;
      font-weight: 600 !important;
      box-shadow: inset 3px 0 0 var(--primary-color);

      i {
        color: var(--primary-color);
      }
    }
  }

  // L3 items in topNav sidebar
  ::v-deep .nav-menu > .el-submenu > .el-menu > .el-menu-item {
    padding-left: 24px !important;
    font-weight: 400 !important;
    color: #606266 !important;
    font-size: 13.5px !important;

    i {
      color: #909399;
      font-size: 13px;
    }

    &.is-active {
      color: var(--primary-color) !important;
      font-weight: 500 !important;

      i {
        color: var(--primary-color);
      }
    }
  }

  // Dark sidebar overrides in topNav mode
  .app-aside[data-sidebar="dark"] {
    ::v-deep .nav-menu > .el-submenu > .el-submenu__title {
      color: rgba(255, 255, 255, 0.85) !important;

      i {
        color: rgba(255, 255, 255, 0.6);
      }

      &:hover {
        background: rgba(255, 255, 255, 0.08) !important;
      }
    }

    ::v-deep .nav-menu > .el-menu-item {
      color: rgba(255, 255, 255, 0.8) !important;

      i {
        color: rgba(255, 255, 255, 0.55);
      }

      &:hover {
        background: rgba(255, 255, 255, 0.06) !important;
      }

      &.is-active {
        color: #ffffff !important;
        background: rgba(255, 255, 255, 0.15) !important;
        box-shadow: inset 3px 0 0 #ffffff;

        i {
          color: #ffffff;
        }
      }
    }
  }

  // Primary sidebar overrides in topNav mode
  .app-aside[data-sidebar="primary"] {
    ::v-deep .nav-menu > .el-submenu > .el-submenu__title {
      color: rgba(255, 255, 255, 0.9) !important;

      i {
        color: rgba(255, 255, 255, 0.65);
      }

      &:hover {
        background: rgba(255, 255, 255, 0.1) !important;
      }
    }

    ::v-deep .nav-menu > .el-menu-item {
      color: rgba(255, 255, 255, 0.85) !important;

      i {
        color: rgba(255, 255, 255, 0.6);
      }

      &:hover {
        background: rgba(255, 255, 255, 0.08) !important;
      }

      &.is-active {
        color: #ffffff !important;
        background: rgba(255, 255, 255, 0.2) !important;
        box-shadow: inset 3px 0 0 #ffffff;

        i {
          color: #ffffff;
        }
      }
    }
  }
}

// ==================== 侧边栏 ====================
.app-aside {
  flex-shrink: 0;
  flex-grow: 0;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.sidebar-search {
  padding: 8px 10px 4px;

  ::v-deep .el-input__inner {
    border-radius: 8px;
    border-color: rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    height: 32px;
    line-height: 32px;

    &:focus {
      border-color: var(--primary-color);
      background: rgba(255, 255, 255, 0.1);
    }
  }

  ::v-deep .el-input__prefix {
    left: 8px;
    color: rgba(255, 255, 255, 0.4);
  }

  ::v-deep .el-input__suffix {
    color: rgba(255, 255, 255, 0.4);
  }

  ::v-deep .el-input__inner::placeholder {
    color: rgba(255, 255, 255, 0.35);
  }
}

// 浅色侧栏搜索框覆盖
.app-aside[data-sidebar="light"] .sidebar-search {
  ::v-deep .el-input__inner {
    border-color: #e4e7ed;
    background: #f5f7fa;
    color: #606266;

    &:focus {
      background: #ffffff;
    }
  }

  ::v-deep .el-input__prefix {
    color: #c0c4cc;
  }

  ::v-deep .el-input__inner::placeholder {
    color: #c0c4cc;
  }
}

// ==================== 折叠状态 ====================
.app-aside[data-collapsed="true"] {
  .sidebar-search { display: none; }

  .sidebar-menu {
    ::v-deep .nav-menu .el-menu-item,
    ::v-deep .nav-menu .el-submenu__title {
      padding: 0 !important;
      text-align: center;
      justify-content: center;

      span { display: none; }
      i { margin: 0 !important; font-size: 18px; }
    }

    ::v-deep .el-submenu__icon-arrow { display: none; }
    ::v-deep .el-submenu > .el-menu { display: none !important; }
  }
}

.app-main {
  background-color: #f5f6f8;
  height: calc(100vh - 56px);
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.main-scrollbar {
  flex: 1;
  overflow: hidden;
}

.main-content-padding {
  padding: 16px;
  min-height: 100%;
  box-sizing: border-box;
}

.main-content-view {
  background: #ffffff;
  min-height: 100%;
  border-radius: 12px;
  border: 1px solid #ebeef5;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02), 0 2px 8px rgba(0, 0, 0, 0.02);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

::v-deep .sidebar-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
}

::v-deep .sidebar-scrollbar .el-scrollbar__view {
  padding: 8px 0 !important;
}

.sidebar-menu {
  background: #ffffff;
  height: calc(100vh - 56px);
  display: flex;
  flex-direction: column;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: background 0.3s ease, border-color 0.3s ease;
}

.app-aside[data-sidebar="dark"] .sidebar-menu {
  background: linear-gradient(180deg, #0B1120 0%, #111827 100%);
  border-right-color: transparent;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.3);
}

.app-aside[data-sidebar="primary"] .sidebar-menu {
  background: var(--primary-color);
  border-right-color: transparent;
}

.sidebar-scrollbar {
  flex: 1;
  height: calc(100vh - 56px);
}

.nav-menu {
  border: none;
  background: transparent;
  padding: 0 !important;
}

::v-deep .el-menu--inline {
  background-color: transparent !important;
  border: none;
  padding: 0 !important;
}

// ==================== 基础菜单项样式 ====================
::v-deep .nav-menu .el-menu-item,
::v-deep .nav-menu .el-submenu__title {
  height: 40px !important;
  line-height: 40px !important;
  margin: 1px 6px !important;
  padding: 0 8px !important;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    background-color: rgba(0, 0, 0, 0.03) !important;
  }
}

// ==================== 一级菜单（目录级） ====================
::v-deep .nav-menu > .el-submenu > .el-submenu__title {
  padding-left: 12px !important;
  font-weight: 700 !important;
  font-size: 15px !important;
  color: #303133 !important;
  height: 44px !important;
  line-height: 44px !important;
  letter-spacing: 0.02em;

  i {
    color: var(--primary-color);
    font-size: 18px;
    margin-right: 8px;
  }
}

::v-deep .nav-menu > .el-menu-item {
  padding-left: 12px !important;
  font-weight: 500 !important;
  color: #303133 !important;

  i {
    color: #606266;
    font-size: 16px;
    margin-right: 8px;
  }

  &.is-active {
    color: var(--primary-color) !important;
    background: linear-gradient(135deg, var(--primary-light) 0%, rgba(240, 247, 255, 0.6) 100%) !important;
    font-weight: 600 !important;
  }

  &.is-active::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 60%;
    background: var(--primary-color);
    border-radius: 0 3px 3px 0;
  }

  &.is-active i {
    color: var(--primary-color);
  }
}

// ==================== 二级菜单 ====================
::v-deep .nav-menu > .el-submenu > .el-menu {
  background-color: transparent !important;
  padding: 4px 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 8px;
    top: 0;
    bottom: 0;
    width: 1px;
    background-color: #e4e7ed;
  }
}

::v-deep .nav-menu > .el-submenu > .el-menu > .el-submenu > .el-submenu__title {
  padding-left: 16px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  height: 38px !important;
  line-height: 38px !important;
  margin: 1px 4px !important;
  color: #606266 !important;

  i {
    font-size: 14px;
    margin-right: 6px;
  }
}

::v-deep .nav-menu > .el-submenu > .el-menu > .el-submenu > .el-menu > .el-submenu > .el-menu::before {
  left: 20px;
}

::v-deep .nav-menu > .el-submenu > .el-menu > .el-menu-item {
  padding-left: 16px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  height: 36px !important;
  line-height: 36px !important;
  margin: 1px 4px !important;
  color: #606266 !important;

  i {
    color: #909399;
    font-size: 14px;
    margin-right: 6px;
  }

  &.is-active {
    color: var(--primary-color) !important;
    background: linear-gradient(135deg, var(--primary-light) 0%, rgba(240, 247, 255, 0.6) 100%) !important;
    font-weight: 600 !important;
  }

  &.is-active::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 60%;
    background: var(--primary-color);
    border-radius: 0 3px 3px 0;
  }

  &.is-active i {
    color: var(--primary-color);
  }

  &::after {
    content: '';
    position: absolute;
    left: 8px;
    top: 50%;
    width: 6px;
    height: 1px;
    background-color: #e4e7ed;
  }

  &.is-active::after {
    background-color: var(--primary-color);
  }

  &:hover::after {
    background-color: #c0c4cc;
  }
}

// ==================== 三级菜单 ====================
::v-deep .nav-menu > .el-submenu > .el-menu > .el-submenu > .el-menu > .el-menu-item {
  padding-left: 24px !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  height: 34px !important;
  line-height: 34px !important;
  margin: 1px 4px !important;
  color: #606266 !important;

  i {
    color: #909399;
    font-size: 13px;
    margin-right: 5px;
  }

  &.is-active {
    color: var(--primary-color) !important;
    background: linear-gradient(135deg, var(--primary-light) 0%, rgba(240, 247, 255, 0.6) 100%) !important;
    font-weight: 600 !important;
  }

  &.is-active::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 60%;
    background: var(--primary-color);
    border-radius: 0 3px 3px 0;
  }

  &.is-active i {
    color: var(--primary-color);
  }

  &::after {
    content: '';
    position: absolute;
    left: 20px;
    top: 50%;
    width: 4px;
    height: 1px;
    background-color: #e4e7ed;
  }

  &.is-active::after {
    background-color: var(--primary-color);
  }

  &:hover::after {
    background-color: #c0c4cc;
  }
}

// ==================== 深色侧栏 ====================
.app-aside[data-sidebar="dark"] {
  // 一级菜单：最亮、最粗、最大
  ::v-deep .nav-menu > .el-submenu > .el-submenu__title {
    color: rgba(255, 255, 255, 0.95);
    font-size: 15px !important;
    font-weight: 700 !important;
    height: 44px !important;
    line-height: 44px !important;
    letter-spacing: 0.02em;
    &:hover {
      background-color: rgba(255, 255, 255, 0.06) !important;
    }
    i { color: #60A5FA; font-size: 18px; }
  }

  // 一级直接菜单项（无子项的特殊目录）
  ::v-deep .nav-menu > .el-menu-item {
    color: rgba(255, 255, 255, 0.85);
    &:hover {
      background-color: rgba(255, 255, 255, 0.06) !important;
    }
    i { color: rgba(255, 255, 255, 0.6); }

    &.is-active {
      background: linear-gradient(90deg, rgba(59, 130, 246, 0.2) 0%, rgba(59, 130, 246, 0.05) 100%);
      color: #93C5FD;
    }
    &.is-active::before { background: #3B82F6; }
    &.is-active i { color: #60A5FA; }
  }

  ::v-deep .nav-menu > .el-submenu > .el-menu > .el-submenu > .el-menu::before {
    background-color: rgba(255, 255, 255, 0.06);
  }

  // 二级菜单：稍暗、稍细
  ::v-deep .nav-menu > .el-submenu > .el-menu > .el-submenu > .el-submenu__title {
    color: rgba(255, 255, 255, 0.7);
    font-size: 13px !important;
    i { color: rgba(255, 255, 255, 0.45); }
    &:hover {
      background-color: rgba(255, 255, 255, 0.04) !important;
    }
  }

  // 二级直接菜单项
  ::v-deep .nav-menu > .el-submenu > .el-menu > .el-menu-item {
    color: rgba(255, 255, 255, 0.6);
    i { color: rgba(255, 255, 255, 0.35); }
    &:hover {
      background-color: rgba(255, 255, 255, 0.04) !important;
    }
    &::after {
      background-color: rgba(255, 255, 255, 0.1);
    }
    &:hover::after {
      background-color: rgba(255, 255, 255, 0.2);
    }

    &.is-active {
      background: rgba(59, 130, 246, 0.15);
      color: #93C5FD;
    }
    &.is-active::before { background: #3B82F6; }
    &.is-active::after { background-color: rgba(59, 130, 246, 0.4); }
    &.is-active i { color: #60A5FA; }
  }

  // 三级菜单项：最暗、最小
  ::v-deep .nav-menu > .el-submenu > .el-menu > .el-submenu > .el-menu > .el-menu-item {
    color: rgba(255, 255, 255, 0.5);
    &:hover {
      background-color: rgba(255, 255, 255, 0.04) !important;
    }
    &::after {
      background-color: rgba(255, 255, 255, 0.08);
    }
    &:hover::after {
      background-color: rgba(255, 255, 255, 0.15);
    }

    &.is-active {
      background: rgba(59, 130, 246, 0.15);
      color: #93C5FD;
    }
    &.is-active::before { background: #3B82F6; }
    &.is-active::after { background-color: rgba(59, 130, 246, 0.4); }
    &.is-active i { color: #60A5FA; }
  }
}

// ==================== 主题色侧栏 ====================
.app-aside[data-sidebar="primary"] {
  ::v-deep .nav-menu > .el-submenu > .el-submenu__title {
    color: rgba(255, 255, 255, 0.95);
    &:hover {
      background-color: rgba(255, 255, 255, 0.1) !important;
    }
    i { color: rgba(255, 255, 255, 0.7); }
  }

  ::v-deep .nav-menu > .el-menu-item {
    color: rgba(255, 255, 255, 0.9);
    &:hover {
      background-color: rgba(255, 255, 255, 0.1) !important;
    }
    i { color: rgba(255, 255, 255, 0.7); }

    &.is-active {
      background: rgba(255, 255, 255, 0.2);
      color: #ffffff;
    }
    &.is-active::before { background: #ffffff; }
    &.is-active i { color: #ffffff; }
  }

  ::v-deep .nav-menu > .el-submenu > .el-menu > .el-submenu > .el-menu::before {
    background-color: rgba(255, 255, 255, 0.1);
  }

  ::v-deep .nav-menu > .el-submenu > .el-menu > .el-submenu > .el-submenu__title {
    color: rgba(255, 255, 255, 0.8);
    i { color: rgba( 255, 255, 255, 0.6); }
    &:hover {
      background-color: rgba(255, 255, 255, 0.08) !important;
    }
  }

  ::v-deep .nav-menu > .el-submenu > .el-menu > .el-menu-item {
    color: rgba(255, 255, 255, 0.7);
    i { color: rgba(255, 255, 255, 0.55); }
    &:hover {
      background-color: rgba(255, 255, 255, 0.08) !important;
    }
    &::after {
      background-color: rgba(255, 255, 255, 0.15);
    }
    &:hover::after {
      background-color: rgba(255, 255, 255, 0.25);
    }

    &.is-active {
      background: rgba(255, 255, 255, 0.2);
      color: #ffffff;
    }
    &.is-active::before { background: #ffffff; }
    &.is-active::after { background-color: rgba(255, 255, 255, 0.5); }
    &.is-active i { color: #ffffff; }
  }

  ::v-deep .nav-menu > .el-submenu > .el-menu > .el-submenu > .el-menu > .el-menu-item {
    color: rgba(255, 255, 255, 0.6);
    &:hover {
      background-color: rgba(255, 255, 255, 0.08) !important;
    }
    &::after {
      background-color: rgba(255, 255, 255, 0.12);
    }
    &:hover::after {
      background-color: rgba(255, 255, 255, 0.2);
    }

    &.is-active {
      background: rgba(255, 255, 255, 0.2);
      color: #ffffff;
    }
    &.is-active::before { background: #ffffff; }
    &.is-active::after { background-color: rgba(255, 255, 255, 0.5); }
    &.is-active i { color: #ffffff; }
  }
}

// ==================== 通用样式覆盖 ====================
::v-deep .el-scrollbar__bar.is-horizontal {
  display: none;
}

::v-deep .el-scrollbar__bar.is-vertical {
  width: 4px;
}

::v-deep .el-scrollbar__thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}

// ==================== 布局模式预览 ====================
.layout-mode-options {
  display: flex;
  gap: 12px;
}

.layout-mode-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  padding: 8px;
  border: 2px solid transparent;
  transition: border-color 0.2s;

  &.active {
    border-color: var(--primary-color);
  }
}

.layout-mode-preview {
  width: 72px;
  height: 44px;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  position: relative;
  overflow: hidden;
}

.layout-preview-sidebar {
  background: #fff;

  .lp-sidebar-bar {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 14px;
    background: #f5f7fa;
  }

  .lp-sidebar-header {
    position: absolute;
    top: 0;
    left: 14px;
    right: 0;
    height: 8px;
    background: #f0f0f0;
  }

  .lp-sidebar-main {
    position: absolute;
    left: 14px;
    top: 10px;
    right: 2px;
    bottom: 2px;
    background: #fafafa;
    border-radius: 2px;
  }
}

.layout-preview-topnav {
  background: #fff;

  .lp-topnav-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 10px;
    background: #f0f0f0;

    &::after {
      content: '';
      position: absolute;
      bottom: 2px;
      left: 8px;
      right: 8px;
      height: 4px;
      background: #e0e0e0;
      border-radius: 1px;
    }
  }

  .lp-topnav-sidebar {
    position: absolute;
    left: 0;
    top: 12px;
    bottom: 0;
    width: 12px;
    background: #f5f7fa;
  }

  .lp-topnav-main {
    position: absolute;
    left: 14px;
    top: 14px;
    right: 2px;
    bottom: 2px;
    background: #fafafa;
    border-radius: 2px;
  }
}

.layout-mode-text {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

// ==================== 主题设置 Drawer ====================
.theme-drawer {
  ::v-deep .el-drawer__header {
    padding: 16px 20px;
    margin-bottom: 0;
    border-bottom: 1px solid #f0f0f0;
    font-weight: 600;
    color: #303133;
  }

  ::v-deep .el-drawer__body {
    padding: 20px;
  }
}

.settings-section {
  margin-bottom: 24px;
}

.settings-label {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 12px;
}

.color-picker-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.color-dot {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.2s;

  &.active {
    border-color: #303133;
  }
}

.style-options {
  display: flex;
  gap: 12px;
}

.style-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  padding: 8px;
  border: 2px solid transparent;
  transition: border-color 0.2s;

  &.active {
    border-color: var(--primary-color);
  }
}

.style-preview {
  width: 60px;
  height: 36px;
  border-radius: 4px;
  overflow: hidden;
}

.style-preview-bar {
  display: block;
  height: 12px;
}

.style-preview-sidebar {
  display: block;
  width: 12px;
  height: 100%;
}

.style-option-text {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.style-preview-tabs {
  width: 60px;
  height: 20px;

  .tabs-mock {
    display: block;
    height: 20px;
    border-radius: 4px;
    background: #f0f0f0;
  }

  .tabs-mock.card {
    border-radius: 6px;
    background: var(--primary-light);
  }

  .tabs-mock.smooth {
    border-radius: 16px;
    background: var(--primary-light);
  }

  .tabs-mock.chunk {
    border-radius: 4px;
    background: var(--primary-color);
  }
}

// ==================== 全局覆盖 ====================
::v-deep .el-card {
  border-radius: 8px;
  border: none;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.3s;
}

::v-deep .el-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

::v-deep .el-card__header {
  padding: 16px 20px;
  border-bottom: 1px solid #f5f5f5;
}

::v-deep .el-card__body {
  padding: 20px;
}

::v-deep .el-table__empty-block {
  min-height: 200px;
}

::v-deep .el-table__empty-text {
  color: #c0c4cc;
  font-size: 14px;
}

::v-deep .el-table {
  font-size: 14px;
}

::v-deep .el-table th {
  background: #fafafa;
  color: #303133;
  font-weight: 500;
}

::v-deep .el-table td {
  color: #606266;
}

.moreCommunity {
  font-weight: 600;
  color: #212529;
  font-size: 12px;
}
</style>
